<template>
  <div>
    <tool-bar pageTitle="Flow.Sight" />
    <v-main class="entrance">
      <div class="entrance__inner">
        <div class="entrance__head">
          <h1>{{ $t('flowSightEntrance.title') }}</h1>
          <h5>{{ $t('flowSightEntrance.subtitle') }}</h5>
        </div>

        <div class="entrance__cards">
          <v-card
            v-for="opt in options"
            :key="opt.product"
            outlined
            color="black"
            class="entrance__card pa-4 rounded-lg"
            @click="choose(opt)"
          >
            <v-chip outlined color="primary" class="pa-2 ma-0">
              <v-icon color="primary">{{ opt.icon }}</v-icon>
            </v-chip>
            <div class="entrance__name">{{ opt.name }}</div>
            <div class="entrance__desc">{{ $t(opt.descKey) }}</div>
            <div class="entrance__hint">{{ $t(opt.hintKey) }}</div>
          </v-card>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import ToolBar from "@/components/layout/ToolBar.vue";
import { useAnalyticsProStore } from "@/store/analyticsStore";
import { FLOW_SIGHT_PRODUCTS, flowSightHome } from "@/utils/flowSightProducts";

export default {
  name: "FlowSightEntrance",
  components: { ToolBar },
  computed: {
    ...mapStores(useAnalyticsProStore),
    options() {
      return FLOW_SIGHT_PRODUCTS;
    },
  },
  methods: {
    choose(opt) {
      // O produto fica no store porque a ingestao de CSV depende dele: cada
      // relatorio tem um layout de colunas proprio. A rota sozinha nao basta -
      // o modal de upload vive fora da subarvore do produto.
      this.analyticsProStore.setFlowSightProduct(opt.product);
      this.$router.push(flowSightHome(opt.product));
    },
  },
};
</script>

<style scoped>
.entrance {
  min-height: 100vh;
  background-image: url("@/assets/BG_1.png");
  background-size: cover;
}
::v-deep .v-main__wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.entrance__inner {
  width: 100%;
  max-width: min(880px, 92vw);
}
.entrance__head {
  margin-bottom: 1.5rem;
}
.entrance__head h1 {
  line-height: 1.15;
}
.entrance__head h5 {
  font-size: 1rem;
  font-weight: 400;
  color: hsl(0, 0%, 65%);
}
.entrance__cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}
@media screen and (max-width: 599px) {
  .entrance__cards {
    grid-template-columns: 1fr;
  }
}
.entrance__card {
  cursor: pointer;
  border: 1px solid transparent !important;
}
.entrance__card:hover {
  border-color: #febd0b6b !important;
}
.entrance__name {
  margin-top: 0.75rem;
  font-size: clamp(17px, 1.1vw + 9px, 24px);
  font-weight: 700;
  letter-spacing: 0.02em;
}
.entrance__desc {
  font-size: 15px;
  color: var(--text-soft);
}
.entrance__hint {
  margin-top: 0.5rem;
  font-size: 12px;
  color: var(--muted);
}
</style>
